import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { BiHide, BiShow } from 'react-icons/bi';

type BsInputPasswordType = {
  label?: string;
  className?: string;
  isInvalid?: boolean;
  rhfControls: any;
  errorMessage?: string;
  passwordRegexInfo?: {
    description: string;
    regex: string;
  };
  startValidating?: boolean;
  isPasswordPatternValid?: boolean;
  isPasswordStrengthBar?: boolean;
};

const BsInputPassword = (props: BsInputPasswordType) => {
  const [show, setShow] = useState(false);
  const [input, setInput] = useState('');
  return (
    <Form.Group className={props.className + ' bsInputPassword'}>
      {props.label ? (
        <Form.Label htmlFor={props.label} className="d-flex align-items-center justify-content-between">
          {props.label}
        </Form.Label>
      ) : null}

      <div className="tw-relative">
        <Form.Control
          autoComplete="new-password"
          id={props.label}
          className=""
          type={show ? 'text' : 'password'}
          isInvalid={props.isInvalid || (props.startValidating && !props.isPasswordPatternValid)}
          isValid={props.isPasswordPatternValid}
          {...props.rhfControls}
          onInput={e => setInput((e.target as any).value)}
        />

        <div
          className="tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-right-0 show-pass bg-transparent border-0 m-0 tw-px-3 h-fit tw-cursor-pointer"
          onClick={() => setShow(!show)}
          onKeyDown={() => setShow(!show)}
          role="button"
          id="btn-show-hide"
          tabIndex={-1}
        >
          {show ? <BiHide size={24} className="tw-text-neutral-400" /> : <BiShow size={24} className="tw-text-neutral-400" />}
        </div>
      </div>
      <Form.Control.Feedback type="invalid" className="d-block font-poppins">
        {props.errorMessage}
      </Form.Control.Feedback>
      {props.passwordRegexInfo && (
        <Form.Text
          className={`${
            props.startValidating && !props.isPasswordPatternValid
              ? 'text-danger'
              : props.startValidating && props.isPasswordPatternValid
              ? 'text-success'
              : 'text-muted'
          }`}
        >
          <>{props.passwordRegexInfo.description.toLowerCase()}</>
        </Form.Text>
      )}
    </Form.Group>
  );
};

export default BsInputPassword;
